module.exports = __webpack_public_path__ + "static/media/f45b56b9-34b5-489d-b02d-238d61a37942.5e2bfa0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/f45b56b9-34b5-489d-b02d-238d61a37942.jpg
// module id = 864
// module chunks = 0